import React from 'react';

import { SimpleLayout } from '@layouts/SimpleLayout';
import { ReviewThanksContainer } from '@containers/ReviewThanks';

import s from './ReviewThankPage.sss';

export const ReviewThankPage: React.FC = () => (
  <SimpleLayout className={s.container}>
    <ReviewThanksContainer className={s.status} />
  </SimpleLayout>
);
